import styled from "styled-components";

const HeroDetails = styled.div`
  display: flex;
  margin: 0 !important;
  background: rgba(34, 34, 34, 0.6);
  position: absolute;
  bottom: 0;
  height: 100px;
  left: 0;
  width: 100%;
  justify-content: center;
`;

export { HeroDetails };
